<ng-template #sidenavRef>
  <vex-sidenav [collapsed]="sidenavCollapsed$ | async"></vex-sidenav>
</ng-template>

<ng-template #toolbarRef>
  <vex-toolbar
    [mobileQuery]="(isDesktop$ | async) === false"
    class="vex-toolbar"
  ></vex-toolbar>
</ng-template>
<ng-template #footerRef>
  <vex-footer *ngIf="isFooterVisible$ | async" class="vex-footer"></vex-footer>
</ng-template>

<vex-layout
  [sidenavRef]="sidenavRef"
  [toolbarRef]="toolbarRef"
  [footerRef]="footerRef"
></vex-layout>
